// extracted by mini-css-extract-plugin
module.exports = {"stackedBar":"style_stackedBar__2NLyD","segment":"style_segment__2ax2b"};